<template>
  <div class="rb-tags-input">
    <div
      class="ui-select-container"
      v-bind="$attrs"
    >
      <div class="main">
        <div
          class="inputs ng-pristine ng-valid ng-valid-pattern ng-valid-maxlength"

          name="vm.tagForm"
          :class="{'border-primary': focused }"
        >
          <SearchInput
            ref="nameEl"
            v-model.trim="input.name"
            :datalist="autoCompleteTags"
            placeholder="New tag name"
            style="width: 133px;"
            pattern="[a-zA-Z0-9_-]*"
            type="text"
            maxlength="30"
            @change="onTagSelected"
          />



          <span>:</span>

          <input
            id="txtValue"
            ref="valueEl"
            v-model="input.textValue"
            name="txtValue"
            class="tagValue form-control no_border m-b-0 p-l-3 ng-pristine ng-untouched ng-valid ng-empty"
            autocomplete="off"
            placeholder="value"
            input-autoresize=""
            :disabled="!input.name"
            style="width: 133px;"
            @keydown="onValueKeyDown"
          >
          <span
            class="input"
            style="visibility: hidden; width: auto; white-space: pre; display: none;"
          >New tag name</span>
          <span
            class="input"
            style="visibility: hidden; width: auto; white-space: pre; display: none;"
          >value</span>
        </div>
        <button
          :disabled="!valid"
          class="btn btn-success btn-sm m-l-10"
          @click.prevent="addTag()"
        >
          Add Tag
        </button>
      </div>

      <!-- Tags -->
      <span class="tags ui-select-match flex-row">
        <span
          v-for="(item, index) in value"
          :key="index"
        >
          <span
            class="ui-select-match-item btn btn-default btn-xs"
            tabindex="-1"
            type="button"
            :disabled="item.disabled"
            ui-select-sort="$select.selected"
          >
            <span
              class="close ui-select-match-close"
              @click="removeTagByIndex(index)"
            >&nbsp;×</span>
            <span uis-transclude-append="">
              <span class="tag-selected-name ng-binding ng-scope">
                {{ item.tagName }}:
                <div class="tag-selected-value ng-binding">
                  {{ item.tagValue }}
                </div>
              </span>
            </span>
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown.vue';
import SearchInput from '@/core/components/SearchInput/SearchInput.vue';
import { GET_TAGS } from '@/modules/info/store/actionTypes';
import {
  computed,
  defineComponent,
  inject,
  reactive,
  ref} from 'vue';
import { mapActions } from 'vuex';
import store from '@/store';

export default defineComponent({
  components: { SearchableDropdown, SearchInput },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props, ctx) {
    const input = reactive({
      name: null,
      textValue: null
    });

    const valid = computed(() => !!(input.name && input.textValue));

    const vm = inject('vm', () => ctx?.attrs?.vm);

    const focused = ref(false);

    const autoCompleteTags = computed(() => {
      const _t = store.state.info?.tags;

      if (_t && Array.isArray(_t)) {
        return _t.filter(t => t.tagType === 'DialedNumber').map(r => r.tagName);
      }

      return [];
    });

    return {
      input,
      vm,
      valid,
      focused,
      autoCompleteTags
    };
  },
  methods: {
    ...mapActions('info', {
      getTags: GET_TAGS
    }),
    async loadAll() {
      if (!this.autoCompleteTags.length) {
        await this.getTags();
      }
    },

    addTag() {
      const newTags = [
        ...this.value,
        {
          tagName: this.input.name,
          tagValue: this.input.textValue
        }
      ];

      this.$emit('input', newTags);

      this.clearInputs();

      this.$refs.nameEl.$el.querySelector('input').focus();
    },

    removeTagByIndex(index) {
      const trimmed = [...this.value];
      trimmed.splice(index, 1);

      this.$emit('input', trimmed);
    },

    clearInputs() {
      this.input.name = '';
      this.input.textValue = '';
    },

    /**
     * @type {(ev: KeyboardEvent) => void}
     */
    onValueKeyDown(ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();

        if (!!this.input.name && !!this.input.textValue) {
          this.addTag();
        }
      }
      console.log(ev.key);
    },

    onTagSelected(ev) {
      this.$refs.valueEl.focus();
    }
  },
  mounted() {
    this.loadAll();
  }
});
</script>

<style lang="scss" scoped>
.inputs {
  &:focus-within {
    border-color: var(--helper-border-primary-color) !important;
  }
}

.main {
  display: flex;
  align-items: baseline;
}

.ui-select-match .close {
  line-height: 1;
  font-size: 1.6em !important;
}
</style>
